module.exports = __webpack_public_path__ + "static/media/rank-empty@2x.7d821197.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/rank-empty@2x.png
// module id = 1006
// module chunks = 0